/**
 * Datumshilfen des Moduls Lohnverrechnung (AP-22-B).
 *
 * Alle Datumsfelder des Moduls sind ISO-Datum ohne Zeitanteil (`YYYY-MM-DD`).
 * Sie werden hier **nie** über die lokale Zeitzone gelesen: `new Date(iso)`
 * ergibt UTC-Mitternacht, und `getDay()`/`getDate()` würden das westlich von
 * Greenwich auf den Vortag zurückrechnen. Dieselbe Klasse Fehler wie die
 * Wall-Clock-Regel der Zeiterfassung (`.claude/rules/zeit-und-datum.md`).
 */

const WEEKDAYS = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];

/** Wochentagsname zu einem ISO-Datum. */
export function weekdayOf(iso: string): string {
  return WEEKDAYS[new Date(`${iso}T00:00:00.000Z`).getUTCDay()] ?? '';
}

/** Wochentagsname zu 1 = Mo … 7 = So (Zählung der Engine). */
export function weekdayName(weekday: number): string {
  return WEEKDAYS[weekday % 7] ?? '';
}

/**
 * ISO-Datum als TT.MM.JJJJ.
 *
 * Bewusst per String-Zerlegung statt `toLocaleDateString` — hier geht es um ein
 * reines Kalenderdatum ohne Zeitpunkt, das keine Zone kennt.
 */
export function formatIsoDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return y && m && d ? `${d}.${m}.${y}` : iso;
}

/** Heutiges Datum als ISO-Datum, aus der lokalen Kalenderansicht des Benutzers. */
export function todayIso(): string {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, '0');
  const d = String(now.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
